import { render, staticRenderFns } from "./Ui.vue?vue&type=template&id=34545239&scoped=true&"
import script from "./Ui.vue?vue&type=script&lang=js&"
export * from "./Ui.vue?vue&type=script&lang=js&"
import style0 from "./Ui.vue?vue&type=style&index=0&id=34545239&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34545239",
  null
  
)

export default component.exports